export default class StaticReportCtrl {

	constructor($scope, $timeout, $mdDialog, $stateParams, $cookies, reportSrv, GlobalConfig, $state, WorkPlanModalSrv, GlobalSrv, permissions, UserInfoConstant) { 
		this.listUser = JSON.parse($cookies.get('currentUser'))
		this.$scope = $scope
		this.rolId = $cookies.get('hasRoleId')
		this.reportSrv = reportSrv
		this.GlobalConfig = GlobalConfig
		this.$mdDialog = $mdDialog
		this.permissions = permissions
		this.buttonDisable = false
		this.UserInfoConstant = UserInfoConstant
		this.timeout = $timeout

		this.header = {
			teacherId                : this.listUser.teacherId,
			workplanId               : this.listUser.workplanId,
			workplanTeacherActivityId: $stateParams.workplanTeacherActivityId,
			name                     : this.listUser.name,
			id                       : this.listUser.id,
		}

		this.workPlanListCombo = []
		this.academicUnitListCombo = []
		this.teachers = []
		this.selectedTeacher = ''
		this.searchText = ''
		this.reportName = []
		this.workPlanName = null
		this.academicUnitName = null
		this.teacherName = null

		this.activate()
	}// FIN DEL CONSTRUCTOR

	showErrorMessages(input) {
		return input.$dirty || input.$touched
	}

	hasError(input) {
		if (input.$invalid && (input.$dirty || input.$touched)) {
			return 'has-error'
		}
	}

	validateForm(form) {
		return form.$invalid
	}

	searchTeacher(teacher) {
		let matcher = new RegExp(teacher, 'i')
		let arr = []
		let attr = 'teacherName'

		this.teachers.forEach((list) => {
			if (list[attr].match(matcher)) {
				arr.push(list)
			}
		})

		return arr
	}

	activate() {
		setTimeout(function() {
			this.n = this.n + 1
		}, 10)
		let post = {
			userId: this.header.id,
			rolId : this.rolId,
		}

		this.reportSrv.getReportDataFilters.get(post).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.workPlanListCombo = dataReturn.listWorkplan
				this.academicUnitListCombo = dataReturn.listAcademicUnit

				this.AllAcadUnit = this.formatedAcademicUnit(dataReturn.listAcademicUnit)
				this.teachers = dataReturn.listTeachers
			} else {
				console.log('Comunications problem with the server')
			}
		}, (data) => {
			console.log(data)
		})
		let param = {
			rolId: this.rolId,
		}

		this.reportSrv.getReportStaticList.get(param).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.reportName = dataReturn.data
			} else {
				console.log('Comunications problem with the server')
			}
		}, (data) => {
			console.log(data)
		})
	}

	formatedAcademicUnit(data) {
		if (!data.length || !data[0].faculty_id) return

		const formatedAcademicUnit = []

		data.forEach(({ faculty_id }) => {
			formatedAcademicUnit.push(...faculty_id.split(',').map(Number))
		})
		
		return formatedAcademicUnit
	}

	generate() {
		this.tea = null
		this.buttonDisable = true

		if (this.rolId == 13) {
			this.tea = this.listUser.teacherId
		} else {
			this.tea = (this.selectedTeacher) ? this.selectedTeacher.teacherId : null
			this.teacherName = (this.selectedTeacher && this.selectedTeacher.teacherName) ? this.selectedTeacher.teacherName : null
		}

		let email = this.listUser.email
		let n = email.length

		let post = {
			workplanId      : this.workplan,
			teacherId       : this.tea,
			academicUnitId  : (this.academicUnit) ? this.academicUnit : this.AllAcadUnit,
			passAcad        : (this.academicUnit) ? 0 : 1,
			username        : this.listUser.dsIdentification,
			userId          : this.listUser.id,
			rolId           : this.rolId,
			email           : email.slice(0, n - 16),
			type            : 1,
			workPlanName    : this.workPlanName, 
			teacherName     : this.teacherName, 
			academicUnitName: this.academicUnitName,
		}

		console.log(post)

		let report = null

		switch (parseInt(this.staticReportName.report_id)) {

		case 1:
			report = this.reportSrv.getReportEvaluators
			break
		case 2:
			report = this.reportSrv.getReportTeacherSpecialSituation
			break
		case 3:
			report = this.reportSrv.getReportTeachersWorkplan
			break
		case 4:
			report = this.reportSrv.getReportWorkPlan
			break
		case 5:
			report = this.reportSrv.getReportTeachersActivityUnit
			break
		case 6:
			report = this.reportSrv.getReportReviewApproved
			break
		case 7:
			report = this.reportSrv.getReportIntegral
			break
		case 8:
			report = this.reportSrv.getStateApprovalByStage
			break
		case 10:
			report = this.reportSrv.getSummaryTeachersActivityUnit
			post.type = 2
			break
		case 11:
			report = this.reportSrv.getReportTeacherActInact
			break
		case 12:
			report = this.reportSrv.getReportHoursPlannedExecuted
			break
		case 13:
			report = this.reportSrv.getReportStateWorkplanTeacher
			break
		case 14:
			report = this.reportSrv.getReportStrategicTracking
			break
		case 15:
			report = this.reportSrv.getReportObservationWorkplan
			break
		case 16:
			report = this.reportSrv.getReportFinancial
			break
		
		}

		if (!report) return false

		report.post(post).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.showModalGeneratingFile()
				this.checkFileReady(dataReturn.filename).then((fileStatus) => {
					if (fileStatus) {
						this.downloadFile(dataReturn.filename)
						this.showModalConfirmSuccess()
						this.buttonDisable = false
					} else {
						this.showModalFailure()
						this.buttonDisable = false
					}
				})
			} else {
				this.showModalFailure()
				this.buttonDisable = false
			}
		}, () => {
			this.showModalFailure()
			this.buttonDisable = false
		})
	}
	checkFileReady (fileName) {
		let params = {
			fileName,
		}

		return this.timeout(() => {
			return this.reportSrv.checkFileReady.get(params).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					if (dataReturn.fileReady) {
						return true
					}

					return this.checkFileReady(fileName)
				} else {
					return false
				}
			})
		}, 5000)
	}

	showModalConfirmSuccess() {
		this.$mdDialog.show({
			controller: [ '$scope', '$mdDialog', function showModalConfirmSuccess($scope, $mdDialog) {
				$scope.close = function () {
					$mdDialog.hide()
				}
			} ],
			template           : require('./successModal.html'),
			clickOutsideToClose: false,
		})
	}

	showModalFailure() {
		this.$mdDialog.show({
			controller: [ '$scope', '$mdDialog', function showModalConfirmSuccess($scope, $mdDialog) {
				$scope.close = function () {
					$mdDialog.hide()
				}
			} ],
			template           : require('./failureModal.html'),
			clickOutsideToClose: false,
		})
	}

	showModalGeneratingFile() {
		this.$mdDialog.show({
			controller: [ '$scope', '$mdDialog', function showModalGeneratingFil($scope, $mdDialog) {
				$scope.close = function () {
					$mdDialog.hide()
				}
			} ],
			template           : require('./generatingFileModal.html'),
			clickOutsideToClose: false,
		})
	}

	downloadFile(filename) {
		let filePath = this.reportSrv.getFilePath(filename)
		let downloadLink = document.getElementById('download')

		downloadLink.href = filePath
		downloadLink.click()
	}

	resetForm () {
		this.workplan = null
		this.academicUnit = null
		this.staticReportName = null

		if (this.selectedTeacher.teacherId != undefined || this.selectedTeacher != null) {
			this.selectedTeacher = null
			this.searchText = ''
		}
	}

	preventInput(event) {
		var vKey = 86

		if (event.keyCode == vKey) {
			event.preventDefault()
		}

		return
	}

	changeSelect(type) {
		if (type == 'workplan') {
			this.workPlanListCombo.forEach(element => {
				if (element.id_code == this.workplan) {
					this.workPlanName = element.ds_name

					return
				}
			})
		}
        
		if (type == 'academicUnit') {
			this.academicUnitListCombo.forEach(element => {
				if (element.faculty_id == this.academicUnit) {
					this.academicUnitName = element.faculty_name

					return
				}
			})
		}
	}

}

StaticReportCtrl.$inject = [ '$scope', '$timeout', '$mdDialog', '$stateParams', '$cookies', 'reportSrv', 'GlobalConfig', '$state', 'WorkPlanModalSrv', 'GlobalSrv', 'permissions', 'UserInfoConstant' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/report/static/staticReportCtrl.js